import { __awaiter, __extends, __generator } from "tslib";
import cn from 'classnames';
import * as React from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { runDelayedWhenVisible } from '../../../../_library/utils/polling';
import { handleThreadHeartbeatOnComponentMount, handleThreadHeartbeatOnComponentUnmount, handleThreadHeartbeatOnComponentUpdate, } from '../../../../_library/utils/thread-heartbeat';
import { DOMAIN_TYPE_CLIENT_NOTIFICATION, NOTIFICATION_ID__THREAD_CREATED, } from '../../../../consts';
import { chatAction, chatActionType, chatSelector } from '../../../chat/chat-redux';
import ChatThread from '../../../chat/components/ChatThread/ChatThread';
import { domainAction, domainSelector, } from '../../../domain/domain-redux';
import { dispatchIsThreadActive } from '../../../domain/ui-state';
import { identitySelector } from '../../../identity/identity-redux';
import { config } from '../../config';
import { url } from '../../url';
import { getSessionThreadId } from '../../utils/app-storage';
import { createDebugLogger } from '../../utils/app-utils';
import { pmaResetExistingMark } from '../../utils/pma-reducer';
import './PageChat.scss';
var PageChatClass = /** @class */ (function (_super) {
    __extends(PageChatClass, _super);
    function PageChatClass(props) {
        var _this = _super.call(this, props) || this;
        _this.debug = createDebugLogger('PageChat');
        _this.stopPolling = function () { return undefined; };
        _this.hasError = false;
        _this._fetchCreateOrRead = function (threadId) { return __awaiter(_this, void 0, void 0, function () {
            var _a, dispatch, identity;
            var _this = this;
            return __generator(this, function (_b) {
                _a = this.props, dispatch = _a.dispatch, identity = _a.identity;
                if (!threadId) {
                    return [2 /*return*/, dispatch(chatAction.createThread(identity))];
                }
                else if (!this.props.typingQueue) {
                    return [2 /*return*/, dispatch(chatAction.readThread(identity, threadId, null, function (e) {
                            console.error(e);
                            if (e.message === 'Network Error' && !window.navigator.onLine) {
                                _this.hasError = false;
                            }
                            else {
                                _this.stopPolling();
                                _this.hasError = true;
                            }
                        }))];
                }
                return [2 /*return*/];
            });
        }); };
        _this._tns = function (id, values, defaultMessage) {
            // @ts-ignore
            return _this.props.intl.formatMessage({ id: "PageChat.".concat(id), defaultMessage: defaultMessage }, values);
        };
        var threadId = _this.props.match.params.threadId;
        // NOTE: nizsie mozno bude treba zahodit... lebo co
        // toto je skaredy reload, ale riesi to ojedinely use-case, kedy sa
        // (manualne) zada "/chat" url napriek tomu, ze exisuje STID
        // NOTE: history.push situaciu neriesi...
        var existingStid = getSessionThreadId(false);
        if (existingStid && !threadId) {
            // this.props.history.push(url.CHAT(existingStid));
            window.location.href = url.CHAT(existingStid);
            return _this;
        }
        return _this;
    }
    PageChatClass.resetStatics = function () {
        PageChatClass.threadIdHandler = void 0;
    };
    PageChatClass.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var threadId;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        threadId = this.props.match.params.threadId;
                        return [4 /*yield*/, this._fetchCreateOrRead(threadId)];
                    case 1:
                        _a.sent();
                        if (threadId) {
                            this.stopPolling();
                            this.stopPolling = runDelayedWhenVisible(this._fetchCreateOrRead, 1000, threadId);
                        }
                        handleThreadHeartbeatOnComponentMount(threadId);
                        return [2 /*return*/];
                }
            });
        });
    };
    PageChatClass.prototype.componentDidUpdate = function (prevProps, prevState) {
        return __awaiter(this, void 0, void 0, function () {
            var threadId, _a, createdThread, dispatch, history, prevThreadId, breakFlow;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        threadId = this.props.match.params.threadId;
                        _a = this.props, createdThread = _a.createdThread, dispatch = _a.dispatch, history = _a.history;
                        prevThreadId = prevProps.match.params.threadId;
                        handleThreadHeartbeatOnComponentUpdate(threadId, prevThreadId);
                        if (typeof PageChatClass.threadIdHandler === 'function') {
                            breakFlow = PageChatClass.threadIdHandler(this, threadId, prevThreadId);
                            if (breakFlow) {
                                return [2 /*return*/];
                            }
                        }
                        if (!(!this.hasError && threadId !== prevThreadId)) return [3 /*break*/, 2];
                        this.stopPolling();
                        if (!threadId) return [3 /*break*/, 2];
                        this.stopPolling = runDelayedWhenVisible(this._fetchCreateOrRead, 1000, threadId);
                        return [4 /*yield*/, this._fetchCreateOrRead(threadId)];
                    case 1: return [2 /*return*/, _b.sent()];
                    case 2:
                        // ak mame notifikaciu a nemame threadId, tak sme najskor prave vytvorili...
                        if (createdThread && createdThread.payload.thread_id) {
                            // tento garbage collect funkcne (aktualne) nema zmysel iny ako udrzovanie poriadku
                            dispatch(domainAction.deleteModelByEntityTypeAndId(DOMAIN_TYPE_CLIENT_NOTIFICATION, createdThread.id));
                            history.push(url.CHAT(createdThread.payload.thread_id));
                        }
                        // ak mame threadId tak si saveneme ui info, ze sme v aktivnom threade
                        if (!this.hasError && threadId) {
                            dispatchIsThreadActive(dispatch, true);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    PageChatClass.prototype.componentWillUnmount = function () {
        var dispatch = this.props.dispatch;
        var threadId = this.props.match.params.threadId;
        dispatchIsThreadActive(dispatch, false);
        // toto je len pre poriadok, v zasade nema velky vyznam (potencialne pre PageMessage)
        dispatch(pmaResetExistingMark(chatActionType.FETCH_READ_THREAD, threadId));
        handleThreadHeartbeatOnComponentUnmount(threadId);
        this.stopPolling();
    };
    PageChatClass.prototype.render = function () {
        var B = config.css.B('-page-chat');
        var threadId = this.props.match.params.threadId;
        var _a = this.props, fetchStatus = _a.fetchStatus, fetchError = _a.fetchError;
        var _render = function () {
            if (threadId) {
                return (React.createElement(ChatThread, { threadId: threadId }) // fetchStatus={fetchStatus}
                );
            }
        };
        return React.createElement("div", { className: cn(B) }, _render());
    };
    return PageChatClass;
}(React.Component));
export { PageChatClass };
// hackish...
// const _reference = {};
/**
 * @param state
 * @param ownProps
 */
var mapStateToProps = function (state, ownProps) {
    var threadId = ownProps.match.params.threadId;
    var createdThread = domainSelector.getClientNotification(NOTIFICATION_ID__THREAD_CREATED)(state);
    var typingQueue = domainSelector.getTypingQueue(state);
    var pmaSelector = threadId
        ? chatSelector.pmaReadThread(state)
        : chatSelector.pmaCreateThread(state);
    return {
        // selectors: Object.assign(_reference, _selectors),
        identity: identitySelector.getIdentity(state),
        createdThread: createdThread,
        typingQueue: typingQueue,
        fetchStatus: pmaSelector.status(threadId),
        fetchError: pmaSelector.lastError(threadId),
    };
};
var mapDispatchToProps = function (dispatch) { return ({ dispatch: dispatch }); };
/**
 *
 */
export var PageChat = withRouter(connect(mapStateToProps, mapDispatchToProps)(injectIntl(PageChatClass)));
// lebo react-loadable s defaultnym exportom vyzaduje menej roboty
export default PageChat;
